<template>
  <panel
    title="Emelőgépek"
    :bodyClass="{ 'd-none': crane_needed == 0 }"
    :noButton="crane_needed == 0"
  >
    <template #headerTools>
      <button
        class="btn btn-xs rounded-pill btn-blue px-4"
        @click="updateCraneNeeded()"
        v-if="can_add"
      >
        <i class="fa fa-plus"></i> Emelőgép hozzáadása
      </button>
    </template>
    <div class="w-100 text-end" style="min-height: 120px">
      <button
        class="btn btn-success rounded-pill"
        v-b-modal="'craneModal' + _uid"
        v-if="can_add"
      >
        <i class="fa fa-plus"></i> Emelőgép hozzáadása
      </button>
    </div>
    <b-modal
      :id="'craneModal' + _uid"
      cancel-variant="default"
      @cancel="closeCraneModal()"
      @ok="addCrane"
      ok-title="Hozzáadás"
      cancel-title="Mégse"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Emelőgép hozzáadása</h4>
        <a class="btn-close" @click="closeCraneModal()"></a>
      </template>
      <form @submit.prevent="addCrane()" v-if="users">
        <div class="mb-2">
          <label class="form-label">Kulcsot elviszi:</label>
          <v-select
            v-model="form.user"
            :options="users.filter((u) => u.pin_set)"
            label="name"
            class="w-80"
            :clearable="false"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                :placeholder="form.user == null ? 'Válassz' : ''"
              />
            </template>
          </v-select>
          <div v-if="errors.user_id" class="invalid-feedback d-block">
            {{ errors.user_id[0] }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label">Emelőgép:</label>
          <v-select
            v-if="cranes"
            v-model="form.crane_id"
            :options="
              cranes.filter(
                (c) => c.operational && (c.location_id == location_id || c.location_id == null)
              )
            "
            :reduce="(option) => option.id"
            label="idname"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!form.crane_id"
                v-bind="attributes"
                v-on="events"
                :placeholder="!form.crane_id ? 'Válassz' : ''"
              />
            </template>
          </v-select>
          <div v-if="errors.crane_id" class="invalid-feedback d-block">
            {{ errors.crane_id[0] }}
          </div>
        </div>
      </form>
      <loading v-else></loading>
    </b-modal>
    <loading v-if="!crane_logs"></loading>
    <div v-else-if="crane_logs.length > 0" style="overflow: scroll">
      <table class="table mt-2">
        <thead>
          <tr class="table-dark">
            <th>Emelőgép sorszáma</th>
            <th>Emelőgép megnevezése</th>
            <th>Kulcsot felvevő</th>
            <th class="align-middle">Kulcsfelvétel</th>
            <th>Kulcs visszahozás</th>
            <th>Kulcsot visszahozta</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, id) in crane_logs" :key="id">
            <td class="align-middle">
              <button
                v-if="!log.taken_at"
                class="btn btn-link"
                @click="removeCrane(log.id)"
              >
                <i class="fa fa-delete-left text-red fa-2x"></i>
              </button>
              {{ log.crane_number }}
            </td>
            <td class="align-middle">{{ log.crane_name }}</td>
            <td class="align-middle">{{ log.user_name_out }}</td>
            <td class="align-middle">
              <button
                v-if="!log.taken_at"
                class="btn btn-white text-blue px-4"
                @click="openKeyModal(log)"
              >
                <i class="fa fa-plus me-1"></i><i class="fa fa-key"></i>
              </button>
              <label class="badge bg-dark">{{ log.taken_at }}</label>
            </td>
            <td class="align-middle">
              <template v-if="log.taken_at">
                <button
                  class="btn btn-white text-blue px-4"
                  v-if="!log.returned_at"
                  @click="openKeyModal(log)"
                >
                  <i class="fa fa-arrow-rotate-left me-1"></i
                  ><i class="fa fa-key"></i>
                </button>
                <label class="badge bg-dark">{{ log.returned_at }}</label>
              </template>
              <span v-else> - </span>
            </td>
            <td class="align-middle">{{ log.user_name_in }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-modal
      id="key-modal"
      no-close-on-backdrop
      no-close-on-esc
      @ok="sendKeyHandle()"
    >
      <template #modal-header="{ cancel }">
        <h4 class="modal-title">
          <Loading
            mini
            class="d-inline-block"
            v-if="!key_to_modal.log"
          ></Loading>
          <span v-else># {{ key_to_modal.log.crane_number }} </span>
          kulcs
          <Loading
            mini
            class="d-inline-block"
            v-if="!key_to_modal.log"
          ></Loading>
          <span v-else>{{
            key_to_modal.log.taken_at ? "visszavétel" : "kiadás"
          }}</span>
        </h4>
        <a class="btn-close" @click="cancel()"></a>
      </template>
      <Loading v-if="!key_to_modal.log"></Loading>
      <div class="text-center" v-else>
        <h2 class="fw-light">Alulírott</h2>
        <v-select
          v-model="key_to_modal.user"
          :options="users.filter((u) => u.pin_set)"
          label="name"
          class="w-80"
          :clearable="false"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              v-bind="attributes"
              v-on="events"
              :placeholder="key_to_modal.user == null ? 'Válassz' : ''"
            />
          </template>
        </v-select>
        <h3 class="fw-light">
          {{ key_to_modal.log.taken_at ? "visszahozom" : "elviszem" }} a
        </h3>
        <h3 class="fw-bold">
          #{{ key_to_modal.log.crane_number }} emelőgép kulcsát
        </h3>
        <div v-if="key_to_modal.log.taken_at">
          <div class="w-350px mx-auto">
            <label class="form-label mt-4 mb-2">Üzemképes az emelőgép?</label>
            <select v-model="key_to_modal.operational" class="form-select">
              <option value="">Válassz</option>
              <option value="1">Igen</option>
              <option value="0">Nem</option>
            </select>
          </div>
          <div class="w-350px mx-auto" v-if="key_to_modal.operational == '0'">
            <label class="form-label mt-4 mb-2">Megjegyzés</label>
            <textarea
              cols="30"
              rows="5"
              class="form-control"
              v-model="key_to_modal.comment"
            ></textarea>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel, ok }">
        <b-button variant="default" @click="cancel()"> Mégse </b-button>
        <PinSignatureSimple
          v-if="
            key_to_modal.user &&
            (!key_to_modal.log.taken_at || key_to_modal.operational != '')
          "
          :user_id="key_to_modal.user.id"
          @signed="ok()"
          :hideSignButton="!key_to_modal.user.pin_set"
        >
        </PinSignatureSimple>
      </template>
    </b-modal>
  </panel>
</template>

<script>
import User from "../../../apis/User";
import Crane from "../../../apis/Crane";
import Loading from "../../../components/Loading";
import PinSignatureSimple from "../../../components/PinSignatureSimple";

export default {
  components: {
    Loading,
    PinSignatureSimple,
  },
  props: ["task_id", "location_id", "crane_needed", "can_add"],
  data() {
    return {
      users: false,
      cranes: false,
      loading: false,
      form: {},
      errors: [],
      crane_logs: false,
      key_to_modal: {
        user: null,
        operational: "",
      },
    };
  },
  created() {
    this.getCranes();
    window.Echo.private("App.Task." + this.task_id)
      .listen("TaskCraneCreated", (e) => {
        this.crane_logs.push(e);
      })
      .listen("TaskCraneUpdated", (e) => {
        const index = this.crane_logs.findIndex((cl) => cl.id == e.id);
        this.crane_logs.splice(index, 1); // Remove the old element
        this.crane_logs.splice(index, 0, e);
        this.getCranes();
        this.$forceUpdate(this.crane_logs);
      })
      .listen("TaskCraneDeleted", (e) => {
        const index = this.crane_logs.findIndex((cl) => cl.id == e.id);
        this.crane_logs.splice(index, 1);
        this.$forceUpdate(this.crane_logs);
      });
  },
  mounted() {
    this.getTaskCranes();
    User.getRoles([6, 10, 11]).then((response) => {
      this.users = response.data;
    });
  },
  methods: {
    getTaskCranes() {
      Crane.getTaskCranes(this.task_id).then((response) => {
        this.crane_logs = response.data;
      });
    },
    getCranes() {
      Crane.index().then((response) => {
        this.cranes = response.data;
      });
    },
    closeCraneModal() {
      this.form = {};
      this.$bvModal.hide("craneModal" + this._uid);
    },
    addCrane(vbModalEvt) {
      if (vbModalEvt) {
        vbModalEvt.preventDefault();
      }
      if (!this.form.user) {
        this.errors = { user_id: ["Válassz munkavégzőt!"] };
      } else if (!this.form.crane_id) {
        this.errors = { crane_id: ["Válassz emelőgépet!"] };
      } else {
        Crane.addToTask(
          this.form.crane_id,
          this.task_id,
          this.form.user.id
        ).then((response) => {
          if (Object.keys(response).length !== 0) {
            this.getTaskCranes();
            this.closeCraneModal();
          }
        });
      }
    },
    removeCrane(log_id) {
      Crane.removeFromTask(log_id).then(() => {
        this.getTaskCranes();
      });
    },
    openKeyModal(log) {
      this.key_to_modal.log = log;
      this.key_to_modal.operational = "";
      this.key_to_modal.user = this.users.find((u) => u.id == log.user_id_out);
      this.$forceUpdate(this.key_to_modal);
      this.$bvModal.show("key-modal");
    },
    sendKeyHandle() {
      this.loading = true;
      if (this.key_to_modal.log.taken_at) {
        Crane.returnKey(this.key_to_modal.log.id, {
          user_id: this.key_to_modal.user.id,
          operational: this.key_to_modal.operational,
          comment: this.key_to_modal.comment,
        })
          .then(() => {
            this.getTaskCranes();
            this.key_to_modal = {
              user: null,
              operational: 1,
            };
          })
          .finally(() => (this.loading = false));
      } else {
        Crane.takeKey(this.key_to_modal.log.id, {
          user_id: this.key_to_modal.user.id,
        })
          .then(() => {
            this.getTaskCranes();
            this.key_to_modal = {
              user: null,
              operational: 1,
            };
          })
          .finally(() => (this.loading = false));
      }
    },
    updateCraneNeeded() {
      Crane.setTaskCrane(this.task_id).then(() => {
        this.$bvModal.show("craneModal" + this._uid);
      });
    },
  },
};
</script>
